import { authHeader,check419 } from "../helpers";

export const userService = {
    login,
    logout,
    forgotPassword,
    resetUserPassword,
    resetPassword,
    addUser,
    getUsersList,
    getUsersListForSetApproval,
    getById,
    update,
    getArchiveUsers,
    deleteUser,
    updateUserStatus,
    verifyOtp
};

function updateUserStatus(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };
 
    return fetch(process.env.REACT_APP_APIURL+"users/updateUserStatus", requestOptions).then(handleResponse)
        .then(usersList => {
            return usersList;
        });
}

function login(email, password) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
    };

    return fetch(process.env.REACT_APP_APIURL+"auth/doSignin", requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem("user", JSON.stringify(user));

            return user;
        });
}

function verifyOtp(email, otp) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp })
    };

    return fetch(process.env.REACT_APP_APIURL + "auth/verify-otp", requestOptions)
        .then(handleResponse)
        .then(response => {
            // Return the response for OTP verification handling
            localStorage.setItem("user", JSON.stringify(response));
            return response;
        });
}


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("user");
    //return loggedOut;
}

function forgotPassword(email) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email})
    };

    return fetch(process.env.REACT_APP_APIURL+"password/reset", requestOptions)
        .then(handleResponse)
        .then(msg => {
            return msg;
        });
}

function resetPassword(resetPassword) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(resetPassword)
    };

    return fetch(process.env.REACT_APP_APIURL+"password/reset/update", requestOptions)
        .then(handleResponse)
        .then(msg => {
            return msg;
        });
}

function resetUserPassword(resetPassword) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(resetPassword)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/changePassword", requestOptions)
        .then(handleResponse)
        .then(msg => {
            return msg;
        });
}

function getUsersList(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/getUsers", requestOptions).then(handleResponse)
        .then(usersList => {
            return usersList;
        });
}

function getUsersListForSetApproval(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/getUsersForSetApproval", requestOptions).then(handleResponse)
        .then(usersList => {
            return usersList;
        });
}

function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_APIURL+`users/getUser/${id}`, requestOptions).then(handleResponse);


}

function addUser(userInfo) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(userInfo)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/saveUsers", requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method:"POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(user)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/updateUsers", requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function deleteUser(id) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(id)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/deleteUsers", requestOptions).then(handleResponse);
}

function getArchiveUsers(search) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(),"Content-Type": "application/json" },
        body: JSON.stringify(search)
    };

    return fetch(process.env.REACT_APP_APIURL+"users/getArchiveUsers", requestOptions).then(handleResponse)
        .then(usersList => {
            return usersList;
        });
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        //const data = text;
        if (!response.ok) {
            if (response.status === 400) {
                // auto logout if 401 response returned from api
                // logout();
                // location.reload(true);
                const error = (data && data?.data?.errors) || response.statusText;
                return Promise.reject(error);
            } else if(response.status === 419){
                check419();
            }

            // const error = (data && data.message) || response.statusText;
            // return Promise.reject(error);
        }

        return data;
    });
}